import { ref, computed } from "vue";
import { fetchUserData } from "@/services/accountService";

/**
 * Lightweight composable that fetches the current user profile (/accounts/users/me)
 * and exposes is_responsible as a computed boolean.
 *
 * Use this in the nav to conditionally show the Statistics tab — it is cheaper
 * than calling the full responsible_stats endpoint.
 */
export function useCurrentUser() {
  const user = ref(null);
  const loading = ref(false);
  const error = ref(null);

  const isResponsible = computed(() => user.value?.is_responsible === true);

  const load = async () => {
    loading.value = true;
    error.value = null;
    try {
      const result = await fetchUserData();
      user.value = result?.data ?? null;
    } catch (e) {
      error.value = e;
      user.value = null;
    } finally {
      loading.value = false;
    }
  };

  return { user, loading, error, isResponsible, load };
}
